/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Tool_Explore_OrganizationInputs */



/**
* | output |
* | --- |
* | "Exploring the organization" |
*
* @param {Uno_Tool_Explore_OrganizationInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_tool_explore_organization = /** @type {((inputs?: Uno_Tool_Explore_OrganizationInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Tool_Explore_OrganizationInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Erkunde Organisation")
	return /** @type {LocalizedString} */ ("Exploring the organization")
});